import { TsuDialog, TsuDialogContent, TsuField } from '@/common/components';
import { Button, DialogActions } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { IOrderShippingsForApproval } from '../../../../common/interfaces';
import { useOrderShippingApproval } from './use-order-shipping-approval';

interface Props {
  open: boolean;
  orderShipping: IOrderShippingsForApproval | null;
  onClose?: () => void;
  onCancel?: () => void;
}

export function CancelDialog(props: Props) {
  const { onClose, onCancel, open, orderShipping } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [comments, setComments] = useState('');
  const { cancelOS, cancelOSMut } = useOrderShippingApproval();

  const handleCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setComments(event.target.value);
  };
  const handleClose = () => onClose?.();
  async function handleCancel() {
    if (orderShipping === null) return;
    await cancelOS({
      variables: {
        input: {
          orderShippingId: orderShipping.orderShipId,
          comments,
        },
      },
    });
    // enqueueSnackbar('Cancelled Order', { variant: 'success' });
    onCancel?.();
    handleClose();
  }

  return (
    <TsuDialog
      open={open}
      loading={cancelOSMut.loading}
      error={cancelOSMut.error}
      title="Cancel Order"
      submitText="Cancel Order"
      onClose={onClose}
      onSubmit={handleCancel}
    >
      <TsuDialogContent>
        <TsuField
          value={comments}
          onChange={handleCommentChange}
          label="Comments (Optional)"
          multiline
          rows={5}
        />
      </TsuDialogContent>
      <DialogActions>
        <Button
            onClick={handleCancel}
            variant="contained"
            sx={{ backgroundColor: '#E35E5D' }}
        >
          Confirm Cancel
        </Button>
      </DialogActions>
    </TsuDialog>
  );
}
